module.exports = __webpack_public_path__ + "img/Menu.Logo.0e1eafc1.png";